import { useEffect, useRef } from 'react';
import { notify } from '../../../utils/notification';
import { activeCommand, commandReminder } from '../../../shared/rules/effects/commandSpell.mjs';

const activeId = combat => {
  const participant = combat?.participants?.[combat?.activeTurn];
  return participant ? String(participant.characterId || participant.enemyId || '') : null;
};

/**
 * Command (2024): when a creature that failed its save starts its turn, remind whoever runs it which command it must
 * follow. The DM screen passes no `controlledIds` (it runs every creature); a character sheet passes its own id.
 * Each command is announced once per turn, including after a refresh.
 */
export default function CommandTurnReminder({ campaignId, combatState, controlledIds, nameFor }) {
  const shown = useRef(new Set());
  const id = Number.isInteger(combatState?.activeTurn) ? activeId(combatState) : null;
  const effect = id && (!controlledIds || controlledIds.map(String).includes(id)) ? activeCommand(combatState.activeEffects, id) : null;
  const key = effect ? `command-reminder:${campaignId || 'none'}:${effect.id}:${combatState.turnSequence}` : null;
  useEffect(() => {
    if (!key || shown.current.has(key)) return;
    shown.current.add(key);
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, 'shown'); } catch { /* Optional deduplication. */ }
    notify(`Command · ${commandReminder(nameFor?.(id) || 'This creature', effect.choice.command)}`, 'warning');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return null;
}
